import { render, staticRenderFns } from "./openended.vue?vue&type=template&id=807ab386&scoped=true&"
import script from "./openended.vue?vue&type=script&lang=js&"
export * from "./openended.vue?vue&type=script&lang=js&"
import style0 from "./openended.vue?vue&type=style&index=0&id=807ab386&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807ab386",
  null
  
)

export default component.exports